module.exports = __webpack_public_path__ + "static/fonts/BMKIRANGHAERANG.7ae1e96.ttf";